import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseServiceWithInterceptor } from "../base-service";
import { ApiRequest } from "../types";
import { GalleryItem, MediaMetadata, TagMetaData } from "./types";

const transformTagsResponse = (response: MediaMetadata) => {
  return {
    ...response,
    tags: response?.tags?.map((tag: TagMetaData) => ({
      ...tag,
      nodeMeasures: tag?.nodeMeasures.sort((a, b) => +a.time - +b.time),
    })),
  };
};

export const mediaApi = createApi({
  reducerPath: "mediaApi",
  baseQuery: createBaseServiceWithInterceptor(process.env.REACT_APP_API_V1_URL),
  tagTypes: ["Media"],
  endpoints: (builder) => ({
    getMediaData: builder.query<
      MediaMetadata,
      { id: string; mediaType: "video" | "image" }
    >({
      query: ({ id, mediaType }) => ({
        url: `media/metadata`,
        params: { fileID: id, mediaType },
      }),
      transformResponse: transformTagsResponse,
    }),

    // getGallery: builder.query<ApiResponse<GalleryItem>, ApiRequest | undefined>(
    //   {
    //     query: (id) => ({
    //       url: `gallery`,
    //     }),
    //   }
    // ),
    getGallery: builder.query<GalleryItem[], ApiRequest | undefined>({
      query: (id) => ({
        url: `gallery`,
      }),
    }),
  }),
});

export const {
  useGetMediaDataQuery,
  useLazyGetGalleryQuery,
  useGetGalleryQuery,
} = mediaApi;
